import React, { FunctionComponent } from "react";
import { Card, CardContent, Box, Chip, Stack, MenuItem } from "@mui/material";
import { CustomTextArea } from "../CustomTextArea";
import { CustomInput } from "../CustomInput";
import { CustomSelect } from "../CustomSelect";
import { CustomDatePicker } from "../CustomDatePicker";
import { Button } from "../Button";
import { useLeadRefundForm } from "./hook";
import { mdiPaperclip, mdiPound, mdiPhone, mdiHelpRhombus } from "@mdi/js";
import { Icon } from "@mdi/react";
import SaveIcon from "@mui/icons-material/Save";
import { CustomSnackbar } from "../CustomSnackbar";

export const LeadRefundForm: FunctionComponent = (): JSX.Element => {
  const {
    state,
    inquiryDate,
    file,
    reasons,
    message,
    isSnackbarOpen,
    snackbarType,
    closeSnackbar,
    onChange,
    onChangeDate,
    onChangeSelect,
    onChangeFile,
    onOpenFileExplorer,
    onRemoveFile,
    onSubmit,
  } = useLeadRefundForm();

  return (
    <Card sx={{ boxShadow: 2, mt: 2, borderRadius: 4 }}>
      <CardContent>
        <Box mt={0}>
          <CustomInput
            startIcon={<Icon path={mdiPound} />}
            name="leadId"
            value={state.leadId}
            onChange={onChange}
            width="100%"
            sx={{ height: 35, pl: 1 }}
            placeholder="lead id..."
            label={{ text: "Lead ID" }}
          />
        </Box>
        <Box mt={4}>
          <CustomDatePicker
            onChange={(newDate) => onChangeDate(newDate)}
            value={inquiryDate}
            width="100%"
            label={{ text: "Inquiry date" }}
          />
        </Box>
        <Box mt={4}>
          <CustomInput
            startIcon={<Icon path={mdiPhone} />}
            name="phone"
            value={state.phone}
            onChange={onChange}
            width="100%"
            sx={{ height: 35, pl: 1 }}
            placeholder="phone number"
            label={{ text: "Phone number" }}
          />
        </Box>
        <Box mt={4}>
          <CustomInput
            startIcon={<Icon path={mdiPound} />}
            name="zip"
            value={state.zip}
            onChange={onChange}
            width="100%"
            sx={{ height: 35, pl: 1 }}
            placeholder="zip code"
            label={{ text: "Zip" }}
          />
        </Box>
        <Box mt={4}>
          <CustomSelect
            name="reason"
            value={state.reason}
            onChange={onChangeSelect}
            StartIcon={<Icon path={mdiHelpRhombus} />}
            width="100%"
            placeholder="Text"
            label="Reason"
          >
            {reasons
              .filter((val) => val.isActive)
              .map((item) => {
                return <MenuItem value={item.id}>{item.description}</MenuItem>;
              })}
          </CustomSelect>
        </Box>
        <Box mt={4}>
          <CustomTextArea
            minLength={0}
            maxLength={300}
            value={state.notes}
            onChange={onChange}
            name="notes"
            width="100%"
            placeholder="Text"
            label={{ text: "Notes" }}
          />
        </Box>
        <input
          name="file"
          onChange={onChangeFile}
          type="file"
          id="file"
          style={{ display: "none" }}
        />
        <Stack direction="row" spacing={2} mt={4}>
          <Button
            placeholder="Text"
            height={35}
            label="Upload a file"
            onClick={onOpenFileExplorer}
          />
          {file && (
            <Chip
              icon={<Icon path={mdiPaperclip} color="white" size={1} />}
              sx={{ bgcolor: "#1BA0E9", color: "white" }}
              label={file.name}
              onDelete={onRemoveFile}
            />
          )}
        </Stack>
      </CardContent>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          width: "100%",
          borderTop: 1,
          backgroundColor: "#FAFAFA",
          borderColor: "#00000026",
          p: 2,
        }}
      >
        <Button
          startIcon={<SaveIcon />}
          width={120}
          height={40}
          label="Save"
          onClick={() => onSubmit()}
        />
      </Box>
      <CustomSnackbar
        level={snackbarType}
        message={message}
        variant="secondary"
        open={isSnackbarOpen}
        onClose={closeSnackbar}
      />
    </Card>
  );
};
